<div
  #panel
  class="floating-dialog-panel mat-elevation-z8"
  [ngStyle]="dialogStyle"
  [cdkTrapFocus]="modal"
  cdkTrapFocusAutoCapture
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragBoundary="body"
>
  <div class="floating-dialog-header" cdkDragHandle>
    <div class="floating-dialog-header-icons" (mousedown)="$event.stopPropagation()">
      <button mat-icon-button disableRipple *ngIf="maximizable" type="button" (click)="onMaximizeToggle()">
        <mat-icon [svgIcon]="isMaximize ? 'fullscreen_exit' : 'fullscreen'"></mat-icon>
      </button>
      <button mat-icon-button disableRipple *ngIf="closable" type="button" (click)="close()">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
  </div>
  <div class="floating-dialog-content" tabindex="-1" cdkFocusInitial>
    <ng-template cdkPortalOutlet></ng-template>
  </div>
  <div class="floating-dialog-resize-handle" *ngIf="resizable && !isMaximize" (mousedown)="startResize($event)"></div>
</div>
